import { toPairs } from 'ramda'

import {
  DesktopReportInOrgInfo,
  DesktopReportInOrgMap,
  DesktopReportsInOrgRequestParams,
} from 'app/common/types/reports/desktop'

import type { Request } from '../../../index'

type ParamsUrlDto = {
  id: string
}

export const convertParams = ({
  orgId,
}: DesktopReportsInOrgRequestParams): [null, ParamsUrlDto] => [null, { id: orgId }]

type ResultDto = Record<
  string,
  {
    restrict_print?: boolean
    school_enabled: boolean
    supplier_enabled: boolean
    supplier_use: boolean
  }
>

export const convertResult = (result: ResultDto): DesktopReportInOrgMap => {
  const pairs = toPairs(result)
  return new Map(
    pairs.map(([id, dto]) => {
      const {
        restrict_print: restrictPrint,
        school_enabled: schoolEnabled,
        supplier_enabled: supplierEnabled,
        supplier_use: supplierUse,
      } = dto

      const report: DesktopReportInOrgInfo = {
        schoolEnabled,
        supplierEnabled,
        supplierUse,
      }

      if (restrictPrint !== undefined) {
        report.restrictPrint = restrictPrint
      }

      return [id, report]
    }),
  )
}

export const GET_SCHOOL_REPORTS_LIST: Request<
  DesktopReportsInOrgRequestParams,
  DesktopReportInOrgMap,
  ParamsUrlDto
> = ['food/schools/{id}/reports_list', 'get', ['data', 'desktop_reports']]
